import Vue from "vue";
import App from "./App.vue";
import Ionic from "@ionic/vue";
import VueRouter from "vue-router";
import axios from "axios";

// Capacitor
import { Plugins } from "@capacitor/core";
const { SplashScreen } = Plugins;

// Firebase
import firebase from "firebase";
import { firebaseConfig } from "./config/firebaseConfig";

// Routing
import router from "./router";

// Ionic and common css
import "@ionic/core/css/ionic.bundle.css";
import "@ionic/core/css/core.css";
import "./theme/common.css";

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Components
import IonicVuePage from "./components/IonicVuePage";
import ErrorMessage from "./components/ErrorMessage";

Vue.use(VueRouter);
Vue.use(Ionic);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

// Set base url for all services
axios.defaults.baseURL = "https://enterprise-api.cellcastcms.com";

// Register global components
Vue.component("ionic-vue-page", IonicVuePage);
Vue.component("error-message", ErrorMessage);

// Initialize firebase
firebase.initializeApp(firebaseConfig);

let app;
// eslint-disable-next-line
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      async mounted() {
        SplashScreen.hide().catch(error => {
          // eslint-disable-next-line
          console.log(error);
        });
      },
      render: h => h(App),
    }).$mount("#app");
  }
});
